module.exports = __webpack_public_path__ + "static/media/blog3.30d11160.png";